import { useEffect, useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Tag, tags as tagsApi } from '../lib/api';
import { formatDate } from '../lib/format';

export function TagsPage() {
  const [tags, setTags] = useState<Tag[]>([]);
  const [newName, setNewName] = useState('');
  const [editing, setEditing] = useState<Tag | null>(null);
  const [loading, setLoading] = useState(true);

  function reload() {
    tagsApi.list().then((res) => setTags(res.tags)).finally(() => setLoading(false));
  }

  useEffect(() => {
    reload();
  }, []);

  async function handleAdd() {
    if (!newName.trim()) return;
    await tagsApi.create(newName.trim());
    setNewName('');
    reload();
  }

  async function handleSaveEdit() {
    if (!editing || !editing.name.trim()) return;
    await tagsApi.update(editing.id, editing.name.trim());
    setEditing(null);
    reload();
  }

  async function handleDelete(id: number) {
    if (!confirm('このタグを削除しますか？すべての友だち・経路から外れます')) return;
    await tagsApi.remove(id);
    reload();
  }

  return (
    <div className="app-shell">
      <Sidebar />
      <main className="page">
        <div className="page-header">
          <div>
            <div className="page-title">タグ管理</div>
            <div className="page-desc">
              友だちや流入経路に付けるタグを管理します。タグは絞り込み検索や（将来の）絞り込み配信で使えます。
            </div>
          </div>
        </div>

        <div className="info-callout">
          <b>追加：</b> タグは友だち詳細パネルや流入経路設定からも追加できます。ここでは一括管理ができます。
        </div>

        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          <input
            className="input"
            style={{ maxWidth: 280 }}
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
            placeholder="新しいタグ名（例: 150cm前後）"
          />
          <button className="btn btn-primary" onClick={handleAdd} disabled={!newName.trim()}>
            + 追加
          </button>
        </div>

        {loading ? (
          <div className="loading">読み込み中...</div>
        ) : (
          <div className="table-card">
            <table>
              <thead>
                <tr>
                  <th>タグ名</th>
                  <th style={{ textAlign: 'right', width: 120 }}>友だち利用数</th>
                  <th style={{ textAlign: 'right', width: 120 }}>経路利用数</th>
                  <th style={{ width: 120 }}>作成日</th>
                  <th style={{ width: 100 }}></th>
                </tr>
              </thead>
              <tbody>
                {tags.map((t) => (
                  <tr key={t.id}>
                    <td>
                      {editing?.id === t.id ? (
                        <input
                          className="input"
                          value={editing.name}
                          onChange={(e) => setEditing({ ...editing, name: e.target.value })}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') handleSaveEdit();
                            if (e.key === 'Escape') setEditing(null);
                          }}
                          autoFocus
                          style={{ maxWidth: 240 }}
                        />
                      ) : (
                        <span className="tag-pill" style={{ fontSize: 12, padding: '4px 10px' }}>
                          #{t.name}
                        </span>
                      )}
                    </td>
                    <td style={{ textAlign: 'right', fontWeight: 500 }}>{t.user_count}</td>
                    <td style={{ textAlign: 'right', fontWeight: 500 }}>{t.route_count}</td>
                    <td style={{ color: 'var(--text-sub)' }}>{formatDate(t.created_at)}</td>
                    <td>
                      <div className="row-actions">
                        {editing?.id === t.id ? (
                          <>
                            <button className="icon-btn-sm" onClick={handleSaveEdit} title="保存">
                              ✓
                            </button>
                            <button
                              className="icon-btn-sm"
                              onClick={() => setEditing(null)}
                              title="キャンセル"
                            >
                              ✕
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="icon-btn-sm"
                              onClick={() => setEditing({ ...t })}
                              title="編集"
                            >
                              ✎
                            </button>
                            <button
                              className="icon-btn-sm danger"
                              onClick={() => handleDelete(t.id)}
                              title="削除"
                            >
                              ✕
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
                {tags.length === 0 && (
                  <tr>
                    <td colSpan={5} className="empty">
                      タグがありません
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </div>
  );
}
